/* eslint-disable eslint-comments/disable-enable-pair -- needed */
/* eslint-disable react/jsx-key -- needed */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types -- needed */
/* eslint-disable react/no-array-index-key -- needed */
/* eslint-disable prefer-template -- needed */
/* eslint-disable no-shadow -- needed */
/* eslint-disable unicorn/no-nested-ternary -- needed */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from '@americanexpress/one-app-router';
import { FormattedMessage, useIntl } from 'react-intl';
import { ExtendReactlytics } from '@americanexpress/reactlytics';
import {
  Button,
  ButtonBase,
  CallToAction,
  Heading,
  mediaQueries,
  useMediaQuery,
} from '@americanexpress/dls-react';
import { Ribbon } from '@americanexpress/web-react-extensions';
import {
  IconMinusCircle,
  IconProcessing,
  IconSuccess,
  IconWarning,
} from '@americanexpress/dls-icons';
import { renderHtml } from '../utils/render-html';
import Body from '../Body';
import LayoutContainer from '../LayoutContainer';
import AnalyticsClick from '../../../../shared/components/analyticsClick';
import Tooltip from './disclaimer-tooltip';
import styles from '../../../styles/viewall.css';
import { layoutTypeResolver, ctaProtocolCheck, MIN_WIDTH_MID_SCREEN } from '../utils';
import QuickViewPortalContainer from '../../../../shared/components/QuickViewPortalContainer';

const ViewAllTile = (props) => {
  const showMobileTileView = props?.showMobileTileView;
  const isListView = props?.isListView;
  const cardname = props?.cardname;
  const benefitNamesList = props?.benefitNamesList;
  const catalogFilters = props?.catalogFilters;
  const searching = props?.searching;
  const benefit = props?.benefit;
  const title = benefit?.title;
  const name = benefit?.name;
  const summary = benefit?.summary;
  const enrollType = benefit?.enrollment?.enrollType;
  const image = summary?.image;
  const copy = summary?.copy;
  const disclaimer = summary?.disclaimer;
  const benefitFeatureLabel = benefit?.benefitFeatureLabel;

  const showStatus = summary?.status?.enabled;
  const statusLabel = summary?.status?.label;
  const ribbonStatusLabel = statusLabel !== '' ? statusLabel : null;
  const enrollmentApplicationStatus = summary?.status?.enrollmentApplication.status;
  const label = statusLabel === 'Enrolled' ? styles.ribbonEnroll : statusLabel?.length < 15 ? styles.ribbonShort : styles.ribbon;
  const maxLabelWidth = statusLabel?.length > 24 && statusLabel?.length < 50;
  const midLabelHeight = statusLabel?.length > 24 && statusLabel?.length < 50;
  const maxLabelHeight = statusLabel?.length > 24 && statusLabel?.length < 50;
  const maxLabelWidthHeight = statusLabel?.length > 50;
  const isMediumBreakPoint = useMediaQuery(mediaQueries.MD_DOWN);
  const isSmallBreakPoint = useMediaQuery(mediaQueries.SM_DOWN);
  const isLargeBreakPoint = useMediaQuery(mediaQueries.LG_UP);
  const analyticsMode = props?.searching === true ? 'search' : 'all-benefits';

  const analyticsImageMode = props?.isListView
    ? `${analyticsMode}>>`
    : 'highlights-tile-';
  // adjust ribbon background color
  const ribbonColorStatus = () => {
    if (enrollmentApplicationStatus === 'enrolled') {
      return '#0E7F79';
    }
    if (enrollmentApplicationStatus === 'pending') {
      return '#C54A00';
    }
    if (enrollmentApplicationStatus === 'rejected') {
      return '#BA2C01';
    }
    return '#344B90';
  };

  // adjust ribbon size for length of label
  const labelLength = () => {
    if (maxLabelWidth) {
      return styles.ribbonMidWidth;
    }
    if (midLabelHeight) {
      return styles.ribbonMidHeight;
    }
    if (maxLabelHeight) {
      return styles.ribbonMaxWidth;
    }
    if (maxLabelWidthHeight) {
      return styles.ribbonMaxWidthHeight;
    }
    if (statusLabel === 'Pending' || statusLabel === 'Rejected') {
      return styles.ribbonEnroll;
    }
    return label;
  };

  const isShowLearnMoreCTA = summary?.learnMoreCTA?.enabled;
  const learnMoreLabel = summary?.learnMoreCTA?.label;
  const learnMoreHref = summary?.learnMoreCTA?.link;
  const productSelected = props?.productSelected;

  const showEnroll = summary?.enrollCTA.enabled;
  const enrollLabel = summary?.enrollCTA?.label;
  const enrollHref = summary?.enrollCTA?.link;

  const showExternal = summary?.externalCTA?.enabled;
  const externalLabel = summary?.externalCTA.label;
  const externalHref = ctaProtocolCheck(summary?.externalCTA?.link);

  const benefitDescription = summary?.copy;

  const detail = benefit?.detail;
  const detailCopy = detail?.copy;
  const detailRequiresLogin = benefit?.detailRequiresLogin;
  const intl = useIntl(); // Hook for accessing locale content, intl.formatMessage()
  const parseEntities = (txt) => new DOMParser().parseFromString(txt, 'text/html').body.textContent;

  // To show quick view modal
  const [showQuickView, setShowQuickView] = useState(false);
  const [benefitsData, setBenefitsData] = useState(props?.benefitsData);
  const toggleModal = () => setShowQuickView(!showQuickView);
  const refreshBenefitsData = (newBenefitsData) => setBenefitsData({ ...newBenefitsData });

  // detail page url
  const detailPage = window.location.origin + learnMoreHref + productSelected;

  // category for each benefit tile
  let benKeyVal = {};

  const benefitsDataKeys = Object.values(benefitsData);

  const categoryObj = benefitsDataKeys?.map((data) => {
    if (!isListView) {
      const benCat = Object?.entries(catalogFilters)?.map(([key, value]) => {
        if (value.includes(data.benefitName)) {
          return key;
        }
        return null;
      });

      const benTitle = Object.values(catalogFilters)?.map((value) => {
        if (value.includes(data.benefitName)) {
          return data.benefitTitle;
        }
        return null;
      });

      benKeyVal = {
        benefitName: data?.benefitName,
        category: benCat?.filter((item) => item !== null),
        title: benTitle?.filter((item) => item !== null),
      };

      return benKeyVal;
    }
    return null;
  });

  const renderCategories = categoryObj.map((item) => {
    let categoryTitle = item?.title[0];
    if (categoryTitle === title) {
      // remove sup, digits and symbols from categoryTitle if it exists in the string
      categoryTitle = categoryTitle?.replace(/<sup>/g, '');
      categoryTitle = categoryTitle?.replace(/<\/sup>/g, '');
      categoryTitle = categoryTitle?.replace(/\W+/g, '');
      categoryTitle = categoryTitle?.replace(/\$\d+/g, '');
      categoryTitle = categoryTitle?.replace(/\d+/g, '');

      return item.category?.map((category, index) => {
        return (
          <li className={`${index === 0 ? 'pad-0-l' : ''} ${styles.category}`}>
            <span className="color-text-subtle">
              <FormattedMessage
                id={`view-all.category.${category.replace(/ /g, '-').toLowerCase()}`}
                defaultMessage={category}
              />
            </span>
          </li>
        );
      });
    }
    return null;
  });

  const mapping = {
    notenrolled: {
      icon: (
        <IconMinusCircle
          color="white"
          size="sm"
        />
      ),
    },
    enrolled: {
      icon: (
        <IconSuccess
          color="white"
          size="sm"
          className={`${!maxLabelWidthHeight ? '' : 'pad-1-t pad-2-l'}`}
        />
      ),
    },
    pending: {
      icon: (
        <IconProcessing
          color="white"
          size="sm"
        />
      ),
    },
    rejected: {
      icon: (
        <IconProcessing
          color="white"
          size="sm"
        />
      ),
    },
    cancelled: {
      icon: (
        <IconProcessing
          color="white"
          size="sm"
        />
      ),
    },
    with_provider: {
      icon: (
        <IconProcessing
          color="white"
          size="sm"
        />
      ),
    },
    unavailable: {
      icon: <IconWarning
        color="white"
        size="sm"
      />,
    },
    failed: {
      icon: <IconWarning
        color="white"
        size="sm"
      />,
    },
    notloggedin: {
      icon: (
        <IconMinusCircle
          color="white"
          size="sm"
        />
      ),
    },
  };

  const enrollmentStatus = enrollmentApplicationStatus in mapping
    ? enrollmentApplicationStatus
    : 'notloggedin';

  const catalogBodyStyle = {
    paddingTop: '5px',
  };

  // Helper to format ribbon label with line breaks
  const formatRibbonStatusLabel = (label) => {
    if (!label || label.length <= 25) return label;
    const words = label.split(' ');
    return words.reduce((acc, word, idx) => {
      const lastLine = acc[acc.length - 1] || '';
      const prevWord = idx > 0 ? words[idx - 1] : '';
      const isNumber = /^\d+$/.test(word);
      if (
        (lastLine + ' ' + word).trim().length > 25
        && !(prevWord.endsWith(':') && isNumber)
      ) {
        acc.push(word);
      } else {
        acc[acc.length - 1] = (lastLine ? lastLine + ' ' : '') + word;
      }
      return acc;
    }, ['']).map((line, idx) => (
      <span key={idx} style={{ display: 'block' }}>{line.trim()}</span>
    ));
  };

  const renderRibbonStatus = () => {
    return (
      <Ribbon
        className="position-absolute-tl"
        variant="platinum"
      >
        {benefitFeatureLabel}
      </Ribbon>
    );
  };
  const isMobileTileView = showMobileTileView || window.innerWidth < MIN_WIDTH_MID_SCREEN;
  const isMobileView = window.innerWidth <= 800;
  const isMobileViewList = () => {
    const offsetMap = {
      large: { top: '-24px', right: '-24px' },
      default: { top: '0px', right: '0px' },
      tabs: { top: '-16px', right: '-16px' },
    };

    let breakPoint;
    if (isLargeBreakPoint) {
      breakPoint = 'large';
    } else if (isMobileTileView && !isMobileView) {
      breakPoint = 'tabs';
    } else {
      breakPoint = 'default';
    }

    const { top, right } = offsetMap[breakPoint];

    return {
      backgroundColor: ribbonColorStatus(),
      top,
      right,
    };
  };

  const quickViewOrDetail = () => {
    if (showMobileTileView || window.innerWidth < MIN_WIDTH_MID_SCREEN) {
      return (
        <Link
          to={`${window.location.origin + learnMoreHref + productSelected}`}
          aria-hidden={true}
          tabIndex={-1}
        >
          <Heading
            level={4}
            variant="sans-xsmall-bold"
            className="margin-2-t-sm-down color-text-brand"
          >
            {renderHtml(title)}
          </Heading>
        </Link>
      );
    }
    return (
      <ButtonBase className="color-text-subtle">
        <Heading
          level={4}
          variant="sans-xsmall-bold"
          className="color-text-brand"
        >
          {renderHtml(title)}
        </Heading>
      </ButtonBase>
    );
  };

  const tileImage = () => {
    return (
      <img
        src={image}
        className="width-full"
        alt=""
        style={{
          width: '100%', cursor: 'pointer', borderRadius: '4px 4px 0 0',
        }}
        aria-hidden={true}
      />
    );
  };

  const ribbonStatusGridLayout = () => {
    if (!isListView && ribbonStatusLabel) {
      return (
        <div
          className={labelLength()}
          style={{
            backgroundColor: ribbonColorStatus(),
            cursor: 'pointer',
            top: '0px',
            right: '0px',
            height: statusLabel?.length < 20 ? '26px' : '',
          }}
          data-testid="label"
        >
          <div style={{
            display: 'flex',
            justifyContent: 'left',
            paddingTop: '5px',
            paddingLeft: maxLabelWidth ? '5px' : '10px',
            alignItems: 'center',
          }}
          >
            {mapping[enrollmentStatus].icon}
            <div
              className={styles.label}
              style={{
                textAlign: 'left',
                paddingLeft: '5px',
                whiteSpace: 'pre-line',
                wordBreak: 'break-word',
              }}
            >
              {formatRibbonStatusLabel(ribbonStatusLabel)}
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  const ribbonStatusListLayout = () => {
    if (isListView && ribbonStatusLabel) {
      return (
        <div className={isMobileView ? '' : styles.container}>
          <div
            className={labelLength()}
            style={{
              ...isMobileViewList(),
              height: statusLabel?.length < 20 ? '26px' : '',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'left',
                paddingTop: '5px',
                paddingLeft: maxLabelWidth ? '5px' : '10px',
                alignItems: 'center',
                paddingRight: maxLabelWidth ? '5px' : '',
              }}
            >
              {mapping[enrollmentStatus].icon}
              <div
                className={styles.label}
                style={{
                  textAlign: 'left',
                  paddingLeft: '5px',
                  whiteSpace: 'pre-line',
                  wordBreak: 'break-word',
                }}
              >
                {formatRibbonStatusLabel(ribbonStatusLabel)}
              </div>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  const tileImageView = () => {
    if (isMobileTileView) {
      return (
        <AnalyticsClick onClick={toggleModal} element={`${cardname?.replace(/ /g, '-').toLowerCase()}>>${analyticsImageMode}image`} benefitNameTag={parseEntities(name)?.replace(/ /g, '-').toLowerCase()}>
          <div className={styles.container}>
            <Link
              to={`${window.location.origin + learnMoreHref + productSelected}`}
              aria-hidden={true}
              tabIndex={-1}
            >
              {tileImage()}
              {isMobileView ? ribbonStatusListLayout() : ''}
              {ribbonStatusGridLayout()}
            </Link>
          </div>
        </AnalyticsClick>
      );
    } return (
      <AnalyticsClick onClick={toggleModal} element={`${cardname?.replace(/ /g, '-').toLowerCase()}>>${analyticsImageMode}image`} benefitNameTag={parseEntities(name)?.replace(/ /g, '-').toLowerCase()}>
        <div className={styles.container}>
          {tileImage()}
          {ribbonStatusGridLayout()}
          {benefitFeatureLabel && renderRibbonStatus()}
        </div>
      </AnalyticsClick>
    );
  };

  const gridLayoutBodyView = () => {
    return (
      <Body title={title} style={catalogBodyStyle}>
        <div className="body-small">
          <ul className="flex-inline pad-0">
            {renderCategories}
          </ul>
        </div>
      </Body>
    );
  };

  const listLayoutBodyView = () => {
    return (
      <>
        <Body shortDescription={copy} isListView={isListView} />
        {disclaimer && (
          <Tooltip disclaimer={disclaimer} title={title} cardname={cardname} />
        )}
      </>
    );
  };

  let finalDetailLink = '';
  if (learnMoreHref?.startsWith('http')) {
    finalDetailLink = learnMoreHref;
  } else {
    finalDetailLink = `${window.location.origin + learnMoreHref + productSelected}`;
  }

  const gridOrListLayoutMobileView = () => {
    if (!isListView) {
      return (
        <div className={`${styles.tileBody} display-flex width-auto pad-2-lr flex flex-column`}>
          <ExtendReactlytics analytics={{ event: { meta: { benefitname: `${parseEntities(title)?.replace(/ /g, '-').toLowerCase()}` } } }}>
            <Link
              href={finalDetailLink}
              className="text-align-left"
              aria-label={parseEntities(`${`${learnMoreLabel} ${intl.formatMessage({ id: 'view-all.card-benefits-tile.about' })} ${title}`}`)}
              data-testid="learn-more-quick-view"
              reactlytics={{ element: `${cardname?.replace(/ /g, '-').toLowerCase()}>>${analyticsImageMode}title`, type: 'click' }}
            >
              {gridLayoutBodyView()}
            </Link>
          </ExtendReactlytics>
          {disclaimer && (
            <div style={{ fontWeight: '400' }}>
              <Tooltip disclaimer={disclaimer} title={title} cardname={cardname} />
            </div>
          )}
        </div>
      );
    } return (
      <div className="flex flex-column width-auto">
        <div className="col-md-8 pad-2-lr pad-0-lr-sm-down">
          <AnalyticsClick onClick={toggleModal} element={`${cardname?.replace(/ /g, '-').toLowerCase()}>>${analyticsMode}>>title`} benefitNameTag={parseEntities(name)?.replace(/ /g, '-').toLowerCase()}>
            {quickViewOrDetail()}
          </AnalyticsClick>
          {listLayoutBodyView()}
        </div>

        <AnalyticsClick onClick={toggleModal} element={`${cardname?.replace(/ /g, '-').toLowerCase()}>>${analyticsMode}>>learn-more`} benefitNameTag={parseEntities(name)?.replace(/ /g, '-').toLowerCase()}>
          <CallToAction className="col-md-4" variant="secondary" asChild={true}>
            <Link
              href={finalDetailLink}
              className="display-block margin-2-t fluid-xs-down flex-align-self-end"
              aria-label={parseEntities(`${`${learnMoreLabel} ${intl.formatMessage({ id: 'view-all.card-benefits-tile.about' })} ${title}`}`)}
              data-testid="learn-more-quick-view-list"
            >
              {learnMoreLabel}
            </Link>
          </CallToAction>
        </AnalyticsClick>
      </div>
    );
  };

  const gridOrListLayoutDesktopView = () => {
    if (!isListView) {
      return (
        <div className={`${styles.tileBody} display-flex width-auto flex flex-column`}>
          <ExtendReactlytics analytics={{ event: { meta: { benefitname: `${parseEntities(name)?.replace(/ /g, '-').toLowerCase()}` } } }}>
            <ButtonBase
              variant="tertiary"
              onClick={toggleModal}
              className="color-text-subtle pad-2-lr text-align-left flex flex-column flex-align-start fluid width-full height-full pad-0-tb"
              aria-label={parseEntities(`${`${learnMoreLabel} ${intl.formatMessage({ id: 'view-all.card-benefits-tile.about' })} ${title}`}`)}
              data-testid="learn-more-quick-view"
              reactlytics={{ element: `${cardname?.replace(/ /g, '-').toLowerCase()}>>${analyticsImageMode}title`, type: 'click' }}
            >
              <Body title={title} shortDescription={benefitDescription} style={catalogBodyStyle}>
                <div className="body-small">
                  <ul className="flex-inline pad-0">
                    {renderCategories}
                  </ul>
                </div>
              </Body>
            </ButtonBase>
          </ExtendReactlytics>
          {disclaimer && (
            <div className="pad-2-l" style={{ fontWeight: '400' }}>
              <Tooltip disclaimer={disclaimer} title={title} cardname={cardname} />
            </div>
          )}
        </div>
      );
    } return (
      <div className="flex width-auto flex-align-items-center">
        <div className="col-md-7 col-lg-8 pad-2-lr pad-3-lr-lg-up">
          <AnalyticsClick onClick={toggleModal} element={`${cardname?.replace(/ /g, '-').toLowerCase()}>>${analyticsMode}>>title`} benefitNameTag={parseEntities(name)?.replace(/ /g, '-').toLowerCase()}>
            <ButtonBase className="color-text-subtle text-align-left" aria-hidden="true" tabIndex={-1}>
              <Heading
                level={4}
                variant="sans-xsmall-bold"
                className="color-text-brand-alt"
              >
                {renderHtml(title)}
              </Heading>
            </ButtonBase>
          </AnalyticsClick>
          <Body shortDescription={copy} isListView={isListView} />
          {disclaimer && (
            <Tooltip disclaimer={disclaimer} title={title} cardname={cardname} />
          )}
        </div>
        <AnalyticsClick onClick={toggleModal} element={`${cardname?.replace(/ /g, '-').toLowerCase()}>>${analyticsMode}>>learn-more`} benefitNameTag={parseEntities(name)?.replace(/ /g, '-').toLowerCase()}>
          <Button
            className="col-md-5 col-lg-4"
            variant="secondary"
            aria-label={parseEntities(`${`${learnMoreLabel} ${intl.formatMessage({ id: 'view-all.card-benefits-tile.about' })} ${title}`}`)}
            data-testid="learn-more-quick-view-list"
          >
            {learnMoreLabel}
          </Button>
        </AnalyticsClick>
      </div>
    );
  };

  const showQuickViewWrapper = () => {
    if (isShowLearnMoreCTA && !isMobileTileView && showQuickView) {
      return (
        <QuickViewPortalContainer
          toggleModal={toggleModal}
          data-testid="quick-view-modal"
          closeButtonLabel="Close"
          dismissible={true}
          closeButtonProps=""
          modalDialogRef={null}
          cardname={cardname}
          name={benefit}
          title={title}
          copy={detailCopy}
          showStatus={showStatus}
          statusLabel={statusLabel}
          enrollmentApplicationStatus={enrollmentApplicationStatus}
          showEnroll={showEnroll}
          enrollLabel={enrollLabel}
          enrollHref={enrollHref}
          enrollType={enrollType}
          showExternal={showExternal}
          externalLabel={externalLabel}
          externalHref={externalHref}
          detailPage={detailPage}
          detailRequiresLogin={detailRequiresLogin}
          benefitNamesList={benefitNamesList}
          benefitsData={benefitsData}
          productSelected={productSelected}
          refreshBenefitsData={refreshBenefitsData}
        />
      );
    }
    return null;
  };

  const mobileViewShowLearnMoreCTA = () => {
    if (isShowLearnMoreCTA && isMobileTileView) {
      return (
        <>
          {isMobileView ? '' : ribbonStatusListLayout()}
          {gridOrListLayoutMobileView()}
        </>
      );
    } return (
      <>
        {ribbonStatusListLayout()}
        {gridOrListLayoutDesktopView()}
      </>
    );
  };

  return (
    global.BROWSER && (
      <>
        <LayoutContainer type={layoutTypeResolver(showMobileTileView, isListView)} searching={searching}>
          {tileImageView()}
          {mobileViewShowLearnMoreCTA()}
        </LayoutContainer>
        {showQuickViewWrapper()}
      </>
    )
  );
};

ViewAllTile.propTypes = {
  benefit: PropTypes.string,
  cardname: PropTypes.string,
  showMobileTileView: PropTypes.bool,
  isListView: PropTypes.bool,
  productSelected: PropTypes.string,
  benefitNamesList: PropTypes.string,
  benefitsData: PropTypes.string,
  catalogFilters: PropTypes.string,
};

export const ComponentUnderTest = ViewAllTile;
export default ViewAllTile;
